import { render } from "./userDetails.vue?vue&type=template&id=22d45a25&scoped=true"
import script from "./userDetails.vue?vue&type=script&lang=js"
export * from "./userDetails.vue?vue&type=script&lang=js"

import "./userDetails.vue?vue&type=style&index=0&id=22d45a25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d45a25"]])

export default __exports__